import _classCallCheck from "C:\\Users\\rose\\Documents\\learning\\card-memory-game\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\rose\\Documents\\learning\\card-memory-game\\node_modules\\@babel\\runtime/helpers/esm/createClass";
export var TrackStateTree =
/*#__PURE__*/
function () {
  function TrackStateTree(master) {
    _classCallCheck(this, TrackStateTree);

    this.pathDependencies = new Set();
    this.shouldTrack = false;
    this.master = master;
    this.proxifier = master.proxifier;
    this.state = master.state;
  }

  _createClass(TrackStateTree, [{
    key: "canMutate",
    value: function canMutate() {
      return false;
    }
  }, {
    key: "canTrack",
    value: function canTrack() {
      return true;
    }
  }, {
    key: "addTrackingPath",
    value: function addTrackingPath(path) {
      if (!this.shouldTrack) {
        return;
      }

      this.pathDependencies.add(path);

      if (this.callback) {
        this.master.addPathDependency(path, this.callback);
      }
    }
  }, {
    key: "track",
    value: function track(cb) {
      var _this = this;

      this.master.changeTrackStateTree(this);
      this.shouldTrack = true;

      if (this.callback) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = this.pathDependencies[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var path = _step.value;
            this.master.removePathDependency(path, this.callback);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }

      this.pathDependencies.clear();

      if (cb) {
        this.callback = function () {
          if (!_this.callback) {
            return;
          }

          cb.apply(void 0, arguments);
        };
      }

      return this;
    }
  }, {
    key: "stopTracking",
    value: function stopTracking() {
      this.shouldTrack = false;
    }
  }, {
    key: "trackScope",
    value: function trackScope(scope, cb) {
      var previousPreviousTree = this.master.previousTree;
      var previousCurrentTree = this.master.currentTree;
      this.master.currentTree = this;
      this.track(cb);
      var result = scope(this);
      this.master.currentTree = previousCurrentTree;
      this.master.previousTree = previousPreviousTree;
      this.stopTracking();
      return result;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      if (!this.callback) {
        this.pathDependencies.clear();
        return this;
      }

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this.pathDependencies[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var path = _step2.value;
          this.master.removePathDependency(path, this.callback);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      this.pathDependencies.clear();
      this.callback = null;
      this.proxifier = this.master.proxifier;

      if (this.master.currentTree === this) {
        this.master.currentTree = null;
      }

      return this;
    }
  }]);

  return TrackStateTree;
}();